import React from 'react';
import { MatchAnalysis } from '../../utils/matchAnalysis';
import TeamLogo, { teamAbbr } from './TeamLogo';

interface MatchPickerProps {
  matches: MatchAnalysis[];
  league: string;
  selected: number;
  onSelect: (index: number) => void;
}

const MatchPicker: React.FC<MatchPickerProps> = ({ matches, league, selected, onSelect }) => (
  <div className="match-picker" role="tablist">
    {matches.map((m, i) => {
      const homeFav = m.winner.home >= m.winner.away;
      return (
        <button
          key={`${m.home}-${m.away}`}
          type="button"
          role="tab"
          aria-selected={i === selected}
          className={`match-picker__tile${i === selected ? ' match-picker__tile--active' : ''}`}
          onClick={() => onSelect(i)}
        >
          <span className={`match-picker__abbr${homeFav ? ' match-picker__abbr--fav' : ''}`}>
            {teamAbbr(m.home, league)}
          </span>
          <TeamLogo team={m.home} league={league} size="sm" />
          <span className="match-picker__vs">vs</span>
          <TeamLogo team={m.away} league={league} size="sm" />
          <span className={`match-picker__abbr${!homeFav ? ' match-picker__abbr--fav' : ''}`}>
            {teamAbbr(m.away, league)}
          </span>
        </button>
      );
    })}
  </div>
);

export default MatchPicker;
